import React from "react";
import * as Yup from "yup";
import { TranslatedText, getValidationRule } from "../../../helpers/helpers";



export const getEmailSchema = () => {
    const validationEmail = getValidationRule('email');

    return Yup.object().shape({
        email: Yup.string()
                .matches(validationEmail,{message: <TranslatedText i18nKey="errors.registration.public.email.match" />})
                .required(  <TranslatedText i18nKey="errors.registration.public.email.required" />)
    })
};       